import { Linkedin } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative py-8 px-6 md:px-12"
    >
      <div className="hr-glow mb-8" />
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-white/25 tracking-wider">
          &copy; 2025 Eminal Dynamics. Todos los derechos reservados.
        </p>
        <a
          data-testid="footer-linkedin"
          href="https://www.linkedin.com/company/eminal-dynamics"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white/25 hover:text-[#00E5FF] transition-colors duration-300"
          aria-label="LinkedIn"
        >
          <Linkedin className="w-4 h-4" />
        </a>
      </div>
    </footer>
  );
}
